module.exports = __webpack_public_path__ + "static/media/green-tick.7b3f46cd.svg";